import React from 'react';
import PropTypes from 'prop-types';
import FolderIcon from 'material-ui-icons/FolderOpen';
import withStyles from 'material-ui/styles/withStyles';
import styles from './styles';

const CollectionItem = props => {
	const {
		item, filesCount, poster, handleShowFiles, classes
	} = props;

	const PosterComponent = poster ?
		(<div className={classes.poster} style={{backgroundImage: `url(${poster})`}}/>) :
		(<FolderIcon className={classes.posterIcon}/>);

	return (
		<div onClick={handleShowFiles} className={classes.container}>
			<div className={classes.preview}>
				{PosterComponent}
			</div>

			<div className={classes.label}>
				<h3 className={classes.title}>{item.name}</h3>
				<p className={classes.counter}>
					{filesCount} file{item.count === 1 ? '' : 's' }
				</p>
			</div>
		</div>
	);
};

CollectionItem.propTypes = {
	item: PropTypes.object.isRequired,
	filesCount: PropTypes.number.isRequired,
	classes: PropTypes.object.isRequired,
	handleShowFiles: PropTypes.func.isRequired,
	poster: PropTypes.string
};

export default withStyles(styles)(CollectionItem);



// WEBPACK FOOTER //
// ./src/client/components/main/collections/item/item.jsx